import { useMediaState } from '@vidstack/react';
import { ClosedCaption } from './closed-caption';
import { CurrentTimeDuration } from './duration';
import { FullScreen } from './full-screen';
import { PlayButton } from './play-button';
import { PlaybackSpeed } from './playback-speed';
import { QuickSeek } from './quick-seek';
import { SeekBar } from './seek-bar';
import { VolumeControls } from './volume-slider';
import { useVideoPlayerContext } from '../../player-context';

type ControlsProps = {
  className?: string;
};
export const Controls = ({ className }: ControlsProps) => {
  const { playerRef } = useVideoPlayerContext();
  const isFullscreen = useMediaState('fullscreen', playerRef!);

  return (
    <div
      className={`${isFullscreen ? 'h-[48px]' : 'h-[40px]'} bg-[var(--scarlet-gray-30)] relative px-03 pt-02 flex items-center ${className}`}
    >
      <SeekBar className="absolute top-0 left-0 w-full" />
      <div className="flex items-center justify-between gap-05 h-[32px] w-full">
        <div className="flex items-center gap-03">
          <PlayButton />
          <QuickSeek />
          <VolumeControls />
          <CurrentTimeDuration />
        </div>
        <div className={`flex items-center ${isFullscreen ? 'gap-03' : ''}`}>
          <PlaybackSpeed />
          <ClosedCaption />
          <FullScreen />
        </div>
      </div>
    </div>
  );
};
